import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import EditUtilityAccountModal from '../../components/modals/UtilityAccountModals/EditUtilityAccountModal';

import EnergyTracerTable from '../../components/tables';
import { linkFormatter } from '../../components/tables/formatters';
import { filterMaskedAccounts } from '../../helpers/resourceFilters';

import AppContext from '../../contexts/app-context';

const styles = {
  buttonDiv: { textAlign: 'right' },
  button: { marginRight: '0.5em', marginLeft: '0.5em' },
};

export default function BuildingAccountsTable(props) {
  const { building, updateAccess, showToast, setBuilding } = props;

  const history = useHistory();
  const { isAdmin } = useContext(AppContext);

  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showAccountModalFlag, setShowAccountModalFlag] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState({});

  const handleEditAccount = (id) => {
    setSelectedAccount(building.accounts.find((acc) => acc.id === id));
    setShowAccountModalFlag(true);
  };

  const handleSetAccount = (data) => {
    setBuilding((prev) => ({
      ...prev,
      accounts: prev.accounts.map((account) => {
        if (account.id !== data.id) return account;
        return data;
      }),
    }));
  };

  useEffect(() => {
    if (showAccountModalFlag) {
      setShowAccountModal(true);
    }
  }, [showAccountModalFlag]);

  const tableColumns = [
    {
      dataField: 'account.account_number',
      text: 'Account',
      formatter: linkFormatter((row) => [
        `/accounts/${row.id}`,
        row.account_number,
      ]),
    },
    {
      dataField: 'account.account_type',
      text: 'Utility Accounts',
      formatter: linkFormatter((row) => [
        `/accounts/${row.id}`,
        row.account_type.charAt(0).toUpperCase() +
          row.account_type.substr(1).toLowerCase(),
      ]),
    },
    {
      dataField: 'building.id',
      text: '',
      formatter: (cell, row) => (
        <div style={styles.buttonDiv}>
          <Button
            variant='edit'
            onClick={() => history.push(`/accounts/${row.id}`)}
            style={styles.button}
          >
            {' '}
            View{' '}
          </Button>
          {updateAccess && (
            <Button
              variant='edit'
              onClick={() => handleEditAccount(row.id)}
              style={styles.button}
            >
              {' '}
              Edit{' '}
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <EnergyTracerTable
        keyField='id'
        columns={tableColumns}
        data={filterMaskedAccounts(building.accounts, isAdmin)}
      />
      <EditUtilityAccountModal
        accountDetails={selectedAccount}
        organization={building.organization}
        buildings={building.siblings}
        defaultBuildings={selectedAccount.building_ids}
        show={showAccountModal}
        onHide={() => {
          setSelectedAccount({});
          setShowAccountModal(false);
          setShowAccountModalFlag(false);
        }}
        handleSetAccount={handleSetAccount}
        showToast={showToast}
        history={history}
      />
    </>
  );
}
